import { Link } from 'react-router-dom'
import cn from 'clsx'

const CollectionsTabSelector = ({ activeTab }) => {
    
    const tabs = [{
        key: 'collections',
        title: 'Personal',
    }, {
        key: 'halfile',
        title: 'HalFILE',
        logo: 'img/county-records-white.png',
    }]
    
    return (
        <div className="join mb-4">
            {tabs.map(({ key, title, logo }) => (
                <Link
                    key={key}
                    className={cn('join-item btn', { 'bg-primary': key === activeTab })}
                    to={`/${key}`}
                    data-test-id={`CollectionsTab-${key}`}>
                    {logo && <img className="h-5" src={logo} alt="countyrecords.com" />}
                    {!logo && title}
                </Link>
            ))}
        </div>
    )
}

export default CollectionsTabSelector
